import { render, staticRenderFns } from "./ExchangeFieldset.vue?vue&type=template&id=20d36c1e"
import script from "./ExchangeFieldset.vue?vue&type=script&lang=js"
export * from "./ExchangeFieldset.vue?vue&type=script&lang=js"
import style0 from "./ExchangeFieldset.vue?vue&type=style&index=0&id=20d36c1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports